import { loadLeadinfo } from './leadInfo'
import { loadGtm } from './tagManager'

export { loadLeadinfo } from './leadInfo'
export { loadGtm } from './tagManager'

export function loadAnalytics(): void {
  loadLeadinfo()
  loadGtm()
}
